import React from 'react';
import { T as Text } from './Text-BCmEgJBp.js';
import { G as Glimmer } from './Glimmer-C-gTChiy.js';

var styles = {"results":"F56prQsXm3A-"};

const DATALIST_TOTALCOUNT_TEST_ID = "ATL-DataList-TotalCount";
function DataListTotalCount({ totalCount, loading, }) {
    if (totalCount === undefined)
        return null;
    let output = null;
    if (totalCount === null && loading) {
        output = React.createElement(Glimmer, { size: "auto", shape: "rectangle" });
    }
    if (typeof totalCount === "number") {
        output = (React.createElement(Text, { variation: "subdued" },
            "(",
            totalCount.toLocaleString(),
            " results)"));
    }
    return (React.createElement("div", { className: styles.results, "data-testid": DATALIST_TOTALCOUNT_TEST_ID }, output));
}

export { DATALIST_TOTALCOUNT_TEST_ID as D, DataListTotalCount as a };
